'use strict'
// Compression is a noop in the browser.
module.exports = function () {}
